import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing, { buildServiceMeta } from '../../utils';
import Row from './row';

const Table = ({ viewType, addons, setAddons, list, total, setTotal }) => {
  // Show a leading "Service" column when the section's header entry has
  // fields.isService === true. The flag lives on the header entry (the one
  // with fields.isHeader: true) so the table renders predictably regardless
  // of row data. Defaults to false — existing tables are unaffected.
  const headerEntry = list.find(addon =>
    _.get(addon, 'fields.isHeader', false)
  );
  const hasServiceColumn = Boolean(
    _.get(headerEntry, 'fields.isService', false)
  );
  const serviceMeta = buildServiceMeta(list, hasServiceColumn);

  const getHeader = headerList => (
    <Thead>
      <Tr>
        {hasServiceColumn && <Th>Service</Th>}
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const result = Object.keys(addons).reduce(
      (acc, current) => {
        const { unitPrice, quantity, isThePriceForDueNow } = addons[current];
        const price = unitPrice * +quantity;

        if (isThePriceForDueNow) {
          acc.dueNow += price;
        } else {
          acc.monthly += price;
        }
        acc.grandTotal += price;

        return acc;
      },
      {
        monthly: 0,
        dueNow: 0,
        grandTotal: 0
      }
    );

    setTotal(previousValue => ({
      ...previousValue,
      addons: result.grandTotal,
      addonsDueNow: result.dueNow,
      addonsMonthly: result.monthly
    }));
  }, [addons]);

  return (
    <table>
      {list.map((addon, index) => {
        if (_.get(addon, 'fields.isHeader', false)) {
          return getHeader(_.get(addon, 'fields.headerList', []));
        }
        const { shouldRender, rowSpan } = serviceMeta[index];
        return (
          <Row
            key={addon.addonName}
            rowData={addon}
            viewType={viewType}
            addons={addons}
            setAddons={setAddons}
            hasServiceColumn={hasServiceColumn}
            serviceLabel={_.get(addon, 'fields.productSectionType', '')}
            renderServiceCell={shouldRender}
            serviceRowSpan={rowSpan}
          />
        );
      })}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={hasServiceColumn ? 4 : 3}>
          <Typography variant={{ bold: true }}>Total</Typography>
        </Td>
        <Td>
          <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.shape({}).isRequired,
  setAddons: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
